import React, { Component } from 'react';

export default class ArrowUp extends Component {

    render(){
        const fillStyle = {fill:this.props.fillColor}
        return (
            <svg width="100%" height="100%" viewBox="0 0 80 80" style={this.props.svgStyle}>
              <g style={fillStyle}>
                <path d="M40.818,13.341c0.574,0.166 1.147,0.485 1.687,0.989l36.178,36.178c0.065,0.069 0.129,0.138 0.193,0.207c1.367,1.686 1.076,2.241 0.968,3.138c-0.339,2.839 -4.269,4.588 -6.635,2.529c-0.071,-0.062 -0.138,-0.128 -0.207,-0.192l-33.183,-33.184l-32.973,32.973c-0.069,0.064 -0.137,0.128 -0.205,0.192c-1.678,1.356 -2.235,1.061 -3.132,0.948c-2.842,-0.358 -4.616,-4.298 -2.572,-6.652c0.062,-0.07 0.128,-0.136 0.191,-0.205l35.95,-35.949c0.759,-0.707 1.078,-0.82 1.668,-0.999c0.693,-0.21 1.406,-0.18 2.072,0.027Z" />
              </g>
            </svg>
        )
    }
}
